const UPPER_TOKENS = new Set(['AS', 'ASA'])

const titleCaseWord = (word: string): string => {
  if (!word) return word
  return word
    .split('-')
    .map((part) =>
      part.length === 0
        ? part
        : part.charAt(0).toLocaleUpperCase('nb-NO') + part.slice(1).toLocaleLowerCase('nb-NO'),
    )
    .join('-')
}

export function formatLeasingselskap(name: string | null | undefined): string {
  if (!name) return ''
  return name
    .split(/(\s+)/)
    .map((token) => {
      if (token.length === 0 || /^\s+$/.test(token)) return token
      if (UPPER_TOKENS.has(token.toLocaleUpperCase('nb-NO'))) {
        return token.toLocaleUpperCase('nb-NO')
      }
      return titleCaseWord(token)
    })
    .join('')
}
